import type { ReactNode } from 'react'

type Props = {
  children: ReactNode
}

export default function Stats({ children }: Props) {
  return <div className='mb-3 grid grid-cols-2 md:grid-cols-4'>{children}</div>
}

Stats.scheme = {
  render: 'Stats',
  children: ['tag']
}
